import {EnvironmentProviders, Provider} from '@angular/core';
import {createFeature, FeatureConfig, provideState} from '@ngrx/store';
import {eventFeatureName, eventReducer, EventState} from './store/event.reducers';
import {provideEffects} from '@ngrx/effects';
import {EventEffects} from './store/event.effects';
import {EventFacade} from './store/event.facade';
import {EventRepository} from './store/event.repository';
import {EventRestService} from './api/event-rest.service';

export function provideEvent(): (EnvironmentProviders | Provider)[] {
    return [
        provideState(createFeature({
            name: eventFeatureName,
            reducer: eventReducer
        } as FeatureConfig<string, EventState>)),
        provideEffects([EventEffects]),
        EventFacade, EventRepository, EventRestService
    ];

}

